module.exports = __webpack_public_path__ + "static/media/icon-Visa.1bd2572d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/icon-Visa.svg
// module id = 2906
// module chunks = 0